import LegalPageLayout from "../components/layout/LegalPageLayout";
import privacyEN from "../content/legal/privacy-en";
import privacyGR from "../content/legal/privacy-gr";

const PrivacyPolicy = () => {
  return (
    <LegalPageLayout
      contentEN={privacyEN}
      contentGR={privacyGR}
      titleKey="meta.privacy.title"
      descriptionKey="meta.privacy.description"
      path="/privacy-policy"
    />
  );
};

export default PrivacyPolicy;
